import React, { useState, useEffect } from "react";
import { toast } from "react-toastify";
import AuthService from "../../services/AuthServices";
import BraidsForm from "../../components/BraidsForm";
import "../../assets/styles/styleUser.css";
import { lineSpinner,zoomies } from "ldrs";
import { colors } from "../../assets/config/color";
import OrderForm from "../../components/order/OrderForm";
import useMediaQuery from "@mui/material/useMediaQuery";
function StylesCenter({ searchStyle }) {
  lineSpinner.register();
  zoomies.register()
  const isSmallScreen = useMediaQuery("(max-width:600px)");
  const [userId, setUserId] = useState();
  const [token, setToken] = useState();
  const [categories, setCategories] = useState([]);
  const [allBraids, setAllBraids] = useState([]);
  const [filteredBraids, setFilteredBraids] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedItem, setSelectedItem] = useState(1000);
  const [isopened, setIsopened] = useState(false);
  const [selectedBraid, setSelecedBraid] = useState(null);
  const getUserData = () => {
    const tok = localStorage.getItem("token");
    const id = localStorage.getItem("id");
    setToken(tok);
    setUserId(id);
  };

  const fetchData = async (fetchFunction, successCallback, errorMessage) => {
    setLoading(true); // Start loading
    try {
      if (token && userId) {
        const response = await fetchFunction(userId, token);
        if (response.data) {
          successCallback(response.data);
        } else {
          toast.error(response.error);
        }
      } else {
        toast.error("Token or User ID is missing");
      }
    } catch (error) {
      toast.error(errorMessage);
    } finally {
      setLoading(false); 
    }
  };

  const handleCategories = () =>
    fetchData(
      AuthService.getBraidsCategories,
      setCategories,
      "Error fetching categories"
    );
 
  const handleBraids = () =>
    fetchData(AuthService.getAllBraids, setAllBraids, "Error fetching braids");

  useEffect(() => {
    getUserData();
  }, []);

  useEffect(() => {
    if (userId && token) {
      handleCategories();
      handleBraids();
    }
  }, [userId, token]);

  const handleFilter = (idCategorie) => {
    const filtered = allBraids.filter(
      (braid) => braid.braid_type_id === idCategorie
    );
    setFilteredBraids(filtered);
  };

  const handleResetFilter = () => {
    setFilteredBraids(allBraids);
  };

  useEffect(() => {
    if (allBraids.length > 0) {
      setFilteredBraids(allBraids);
    }
  }, [allBraids]);

  const handleBraidClick = (id) => {
    const braid = allBraids.find((braid) => braid.id === id);
    setSelecedBraid(braid);
    setIsopened(true);
  };
  const applyFilters = () => {
    let filtered = allBraids;
    if (selectedItem !== 1000) {
      const selectedCategory = categories[selectedItem];
      if (selectedCategory) {
        filtered = filtered.filter(
          (braid) => braid.braid_type_id === selectedCategory.id
        );
      }
    }
    if (searchStyle.trim() !== "") {
      filtered = filtered.filter((braid) =>
        braid.name.toLowerCase().includes(searchStyle.toLowerCase())
      );
    }

    setFilteredBraids(filtered);
  };
  useEffect(() => {
    applyFilters();
  }, [searchStyle, selectedItem, allBraids]);
  const useWindowSize = () => {
    const [windowSize, setWindowSize] = useState({
      width: window.innerWidth,
      height: window.innerHeight,
    });
  
    useEffect(() => {
      const handleResize = () => {
        setWindowSize({
          width: window.innerWidth,
          height: window.innerHeight,
        });
      };
  
      // Écoute les événements de redimensionnement
      window.addEventListener('resize', handleResize);
  
      // Nettoyage de l'événement à la destruction du composant
      return () => window.removeEventListener('resize', handleResize);
    }, []);
  
    return windowSize;
  };
  const { width, height } = useWindowSize();
  return (
    <div >
      {isopened ? (
        <OrderForm onCancel={() => setIsopened(false)} braid={selectedBraid} />
      ) : (
        <div className="main-contentHS" style={{ width: isSmallScreen ? width - 6 : '100%' }} >
          <div className="padding">
            <div className="main-content">
              <div className="menuItem" >
                <div className="rowItem itemM" >
                  <span
                    className={selectedItem === 1000 ? "selected" : ""}
                    onClick={() => {
                      setSelectedItem(1000);
                      handleResetFilter();
                    }}
                  >
                    All
                  </span>
                  {
                    loading ?<l-zoomies
                    size="80"
                    stroke="5"
                    bg-opacity="0.1"
                    speed="1.4" 
                    color={colors.gold}
                  ></l-zoomies>:
                  
                  categories.length > 0 ? (
                    categories.map((item, index) => (
                      <span
                        key={item.id}
                        className={selectedItem === index ? "selected" : ""}
                        onClick={() => {
                          setSelectedItem(index);
                          handleFilter(item.id);
                        }}
                      >
                        {item.name}
                      </span>
                    ))
                  ) : (
                    <p style={{ margin: 0 }}>No available styles</p>
                  )}
                </div>
              </div>
             
           
              <div className="rowM">
                {loading ? (
                  <div className="spinner">
                    <l-line-spinner
                      size="50"
                      color={colors.gold}
                    ></l-line-spinner>
                  </div>
                ) : filteredBraids.length > 0 ? (
                  <BraidsForm
                    allBraids={filteredBraids}
                    onDishClick={handleBraidClick}
                    selectedDish={selectedBraid}
                  />
                ) : (
                  <p>no braids available</p>
                )}
                
              </div>
          </div>
        </div>
        </div>
      )}
    </div>
  );
}

export default StylesCenter;
